<!-- 竞猜下注 游戏币 -->
<template>
<el-dialog
    class="guess-bet-gold"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
       
        <div class="close" @click="closeHandler"><img :src="require('../assets/close-gavy.png')" alt="" height="20"></div>
        <div class="title-head">
            <div class="main">金币竞猜</div>
        </div>
        <!-- <div class="cont-row change-team">
            <el-radio-group v-model="params.option">
                <div class="box"><BallRadio :label="1" class=""><div class="team-ball-radio"><div>{{info.team1.name}}胜</div><div> {{info.team1.odds}}倍</div></div></BallRadio></div>
                <div class="box"><BallRadio :label="3" class=""><div class="team-ball-radio"><div>平局</div><div> {{info.tie.odds}}倍</div></div></BallRadio></div>
                <div class="box"><BallRadio :label="2" class=""><div class="team-ball-radio"><div>{{info.team2.name}}胜 </div><div>{{info.team2.odds}}倍</div></div></BallRadio></div>
            </el-radio-group>
        </div> -->
        <div class="change-team">
            <ul class="team-list">
                <li :class="{active:params.option == 1}"><div class="box" @click="params.option =1"><div>{{info.team1.name}}胜</div><div> {{info.team1.odds}}倍</div></div></li>
                <li :class="{active:params.option == 3}"><div class="box" @click="params.option =3"><div>平局</div><div> {{info.tie.odds}}倍</div></div></li>
                <li :class="{active:params.option == 2}"><div class="box" @click="params.option =2"><div>{{info.team2.name}}胜 </div><div>{{info.team2.odds}}倍</div></div></li>
            </ul>
            <div class="change-result">
                下注
                <span v-if="params.option == 1 ">{{info.team1.name}}</span>
                <span v-if="params.option == 2 ">{{info.team2.name}}</span>
                <span v-if="params.option == 3 ">平局</span>
                ，请选择投币数量
            </div>
        </div>

        
        <div class="my-gold">我的金币：{{user.gold}}，请下注：</div>
        
        <div class="bet-group-box">
            <el-radio-group v-model="params.amount" class="bet-group">
                <div class="item">
                    <BallRadio :label="50" class="gold">
                        <div class="bet-contain">
                            <div class="gold-box"><img :src="require('../assets/gold-1.png')" alt="" height="20"></div>
                            <div class="bet-txt">50</div>
                        </div>
                    </BallRadio>
                </div>
                <div class="item">
                    <BallRadio :label="100" class="gold">
                        <div class="bet-contain">
                            <div class="gold-box"><img :src="require('../assets/gold-2.png')" alt="" height="30"></div>
                            <div class="bet-txt">100</div>
                        </div>
                    </BallRadio>
                </div>
                <div class="item">
                    <BallRadio :label="200" class="gold">
                        <div class="bet-contain">
                            <div class="gold-box"><img :src="require('../assets/gold-3.png')" alt="" height="30"></div>
                            <div class="bet-txt">200</div>
                        </div>
                    </BallRadio>
                </div>
                <div class="item">
                    <BallRadio :label="500" class="gold">
                        <div class="bet-contain">
                            <div class="gold-box"><img :src="require('../assets/gold-4.png')" alt="" height="30"></div>
                            <div class="bet-txt">500</div>
                        </div>
                    </BallRadio>
                </div>
                <div class="item">
                    <BallRadio :label="1000" class="gold">
                        <div class="bet-contain">
                            <div class="gold-box"><img :src="require('../assets/gold-4.png')" alt="" height="30"></div>
                            <div class="bet-txt">1000</div>
                        </div>
                    </BallRadio>
                </div>
                <div class="item">
                    <BallRadio :label="null" class="gold">
                        <div class="bet-contain">
                            <div class="gold-box"><img :src="require('../assets/gold-4.png')" alt="" height="30"></div>
                            <div class="bet-txt"><input class="custom-amount" type="text" @focus="params.amount = null" v-model.trim="customAmount" placeholder="输入金额"></div>
                        </div>
                    </BallRadio>
                </div>
                
                
                
            </el-radio-group>
        </div>
        <div class="note-text">预计获得{{resultCoin}}金币</div>
        <div class="bet-btn">
            <div class="now-bet" @click="nowBetDown" v-loading="postLoading">立 即 下 注</div>
        </div>
        
    </div>
    <div class="sponser-banner" v-if="info.sponsor"><img :src="info.sponsor.image2" alt=""></div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
</el-dialog>
</template>
<script>
import BallRadio from '../common/ball-option.vue'
export default {
    name :'GuessingBetGold',
    props:['status','info'],
    components:{BallRadio},
    computed:{
        user(){
            return this.$store.getters.user;
        },
        resultCoin(){
            var odds = 1;
            switch(this.params.option){
                case 1:
                    odds = this.info.team1.odds;
                    break;
                case 2:
                    odds = this.info.team2.odds;
                    break;
                case 3:
                    odds = this.info.tie.odds;

            }
            if( this.params.amount == null ){
                
                return Math.round(odds * parseInt(this.customAmount)) || 0;
            }else{
                return Math.round(odds*this.params.amount)
            }
            
        }
    },
    data(){
        return {
            params:{
                "gameId": null,
                "option": 1,
                "amount": 50
            },
            postLoading:false,
            customAmount:'',
        }
    },
    methods:{
        closeHandler(){
            if( this.postLoading) return false;
            this.params={
                "gameId": null,
                "option": 1,
                "amount": 50
            }
            this.$emit('update:status',false)
        },
        async nowBetDown(){
            if(this.postLoading ) return false;
            if( this.params.option == null){
                this.$warning('请选择支持的队伍');
                return false;
            }
            if( this.params.amount == null ){
                if(this.customAmount.length == 0 ){
                    this.$warning('请选择下注金额');
                    return false;
                }else{
                    if( /^\d+$/.test(this.customAmount) == false ){
                        this.$warning('下注金额请输入数字');
                        return false;
                    }
                }
            }

            let sendData = {...this.params};
            sendData.gameId = this.info.id
            if( this.params.amount == null ){
                sendData.amount = parseInt(this.customAmount)
            }   
            
            
            if( sendData.amount > this.user.gold){
                this.$warning('您的金币不足，无法下注！');
                return false;

            }
            
            this.postLoading = true;
       
            let result = await this.$axios.post('/worldcup2022/gold/coin/place/a/bet/for/result/game',sendData).finally(()=>{

                this.postLoading = false;
            })
            if( result.code == 0 ){
                this.$success('下注成功!');
                this.closeHandler();
                this.$emit('success');
            }

        }


    }
}
</script>
<style lang="less" scoped>
.guess-bet-gold{
    /deep/.el-dialog{width:375px; background: none; border-radius: 10px; padding:0;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .guess-bet-gold{

        /deep/.el-dialog{width:100%; }
    }
}

.ball-cup-container{
    background-image:linear-gradient(180deg,#fff8da, #ffffff 71%); border-radius: 10px 10px 0 0; position: relative;border-radius: 10px 10px 0 0 ; padding: 10px 20px;
    .close{position: absolute; right: 20px; top: 12px; cursor: pointer;}
    .title-head{
        margin-bottom: 10px; display: flex; align-items: center;
        .main{font-size: 16px; line-height: 22px; color: #111; font-weight: 600; margin-right: 10px;}
        .subf{font-size: 16px; line-height: 24px; color: #999;}
        .other{font-size: 14px; color: #111;}

    }
}
.change-team{
    padding: 20px 15px 15px;background: #fff7cd;border: 1px solid #f8e488;border-radius: 10px; margin-bottom: 15px;
    .team-list{
        display: flex; align-items: center; margin:0 -3px;
        li{
            flex:1; padding: 0 3px;
            .box{
                position: relative; background: #fff;box-shadow: 0px 3px 0px 0px #e1cf7b; border-radius: 6px; text-align: center;
                font-size: 12px; line-height: 18px; color: #333; padding: 6px 0;
                user-select: none;cursor: pointer;
                div:first-child{font-size: 14px; line-height: 20px; color: #111; font-weight: 600;}
                
            }
            &.active{
                .box{
                    box-shadow:0 3px 0 0 #931BBF;
                    &:before{
                        content: ''; position: absolute; left:0; top: 0; right: 0; bottom: 0; border:2px solid #931BBF; border-radius: 6px;
                    }
                    &:after{
                        content: ''; position: absolute; right: 0; bottom: 0;width:25px; height: 20px; background: url(../assets/gamblers-gold-check.png); background-size: 100%;
                    }
                }
            }
        }
    }
    .change-result{
        text-align: center; margin-top: 15px;font-size: 14px;  line-height: 20px; 
        span{color: #931BBF; font-weight: bold;}
    }
}
.my-gold{font-size: 14px; line-height: 20px; color: #333; margin-bottom: 15px; text-align: center;}
.bet-group-box{
    margin:0 5px 5px;
    .bet-group{
        display: flex; flex-wrap: wrap; 
        .item{
            padding: 0 10px; width:33.33%; box-sizing: border-box; margin-bottom: 15px;
            .team-win{
                margin: 0; position: relative; width: 100%; border:2px solid #F7EBB0; border-radius: 12px;
                padding: 5px 10px;
                &.is-checked{
                    border-color: #931BBF;
                    &:after{
                        background-image: url(../assets/gamblers-gold-check.png);
                        width:24px;height: 21px;
                        right: 0px; bottom: 0px;
                    }
                }

            }
        }
        .bet-contain{
            .gold-box{
                height: 30px; display: flex; align-items: center; justify-content: center; padding-top: 5px;
            }
            .bet-txt{
                font-size: 16px; line-height: 30px; color: #111; text-align: center; font-weight: bold;
                .custom-amount{border: none; width: 100%; box-sizing: border-box; line-height: 20px; padding: 5px; width: 100%; text-align: center;}
            }
        }
    }
}

.note-text{font-size: 14px; line-height: 20px; color: #333; margin-bottom: 7px; text-align: center;}
.bet-btn{
    text-align: center;
    .now-bet{
        display: inline-block; padding: 0 45px;
        background: #931BBF;
        font-size: 17px; line-height: 50px; color: #fff; cursor: pointer;
        border-radius: 25px;font-weight: bold;
        &:hover{     
             background: #74069C;     
            //background-image: linear-gradient(180deg,#FFE01D, #E7A41C 52%, #EBB500);
        }
    }
}

.bet-title-text{font-size: 18px; line-height: 24px; margin-bottom: 15px; color: #111; font-weight: bold;}

.sponser-banner{
    background: linear-gradient(180deg,#e2d9ae, #ffffff);
    padding: 10px;
    img{display: block; width:100%; object-fit: cover;}
}
</style>